import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  consumerDetails: {},
  userDetails: {},
  isAnGuestUser: false,
  s3Uploads: {},
}

const userSlice = createSlice({
  name: 'userSlice',
  initialState,
  reducers: {
    setConsumerDetails: (state, action) => {
      state.consumerDetails = action.payload
    },
    setSubcategorsetConsumerDetailsies: (state, action) => {
      state.consumerDetails = action.payload
    },
    setUserDetails: (state, action) => {
      window.countryID = action.payload.countryID
      window.countryCode = action.payload.ISOCountryCode || 'US'
      state.userDetails = action.payload
    },
    setUserAddresses: (state, action) => {
      state.locations = action.payload
    },
    setAppLegalConfigs: (state, action) => {
      state.appLegalConfigs = action.payload
    },
    setEntityList: (state, action) => {
      state.availableBrandsList = action.payload
    },
    guestUserLoggedIn: (state, action) => {
      state.isAnGuestUser = action.payload.status
    },
    setSelectedBrand: (state, action) => {
      state.selectedBrand = action.payload
    },
    setSelectedPlan: (state, action) => {
      state.selectedPlanDetails = action.payload
    },
    setPlansList: (state, action) => {
      state.brandPlansList = action.payload
    },
    setBrandBannersList: (state, action) => {
      state.brandBannersList = action.payload
    },
    setStateAddressListConfig: (state, action) => {
      state.stateAddressListConfig = action.payload
    },
  },
})

export default userSlice.reducer

export const {
  setConsumerDetails,
  setUserDetails,
  setAppLegalConfigs,
  setEntityList,
  guestUserLoggedIn,
  setSelectedBrand,
  setSelectedPlan,
  setPlansList,
  setBrandBannersList,
  setUserAddresses,
  setStateAddressListConfig,
} = userSlice.actions
